import React from 'react';
import { Layout as LayoutAntd } from "antd";
import { Outlet } from 'react-router';

const { Content } = LayoutAntd;

const Layout = () => {
  return (
    <LayoutAntd>
      <Content style={{ marginTop: 0 }}>
        <Outlet />
      </Content>
    </LayoutAntd>
  )
}

export default Layout
